import { c as _c } from "react/compiler-runtime";
import { alpha, Box, useTheme } from "@mui/material";
import React, { useMemo } from "react";
import { arrayDataItemSelectors } from "#/entities/dataStructures/array/model/arraySlice";
import { ArrayItem } from "#/entities/dataStructures/array/ui/ArrayItem";
import { type ArrayStructureViewProps } from "#/entities/dataStructures/array/ui/ArrayStructureView";
type MatrixRowProps = ArrayStructureViewProps & {
  header?: string;
};
export const MatrixRow: React.FC<MatrixRowProps> = t0 => {
  const $ = _c(19);
  const {
    data,
    header,
    parentColorMap,
    sx
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== data.nodes) {
    t1 = arrayDataItemSelectors.selectAll(data.nodes);
    $[0] = data.nodes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const items = t1;
  let t2;
  if ($[2] !== theme.palette.primary.light) {
    t2 = alpha(theme.palette.primary.light, 0.032);
    $[2] = theme.palette.primary.light;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      backgroundColor: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== sx || $[7] !== t3) {
    t4 = {
      "&:hover": t3,
      ...sx
    };
    $[6] = sx;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== header) {
    t5 = header ? <th scope="row">{header}</th> : null;
    $[9] = header;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== data.colorMap || $[12] !== items || $[13] !== parentColorMap) {
    t6 = items.length > 0 ? items.map(item => <td key={item.id}><ArrayItem colorMap={data.colorMap ?? parentColorMap} isGrid={true} item={item} /></td>) : <Box component="td" sx={{
      width: 44,
      height: 44
    }} />;
    $[11] = data.colorMap;
    $[12] = items;
    $[13] = parentColorMap;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <Box component="tr" sx={t4}>{t5}{t6}</Box>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};